export default __webpack_public_path__ + "static/media/54-amethyst-light-min.62e04a4a.png";